"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryStorage = exports.InMemoryStorage = void 0;
class InMemoryStorage {
    constructor() {
        this.storage = new Map();
    }
    get length() {
        return this.storage.size;
    }
    clear() {
        this.storage.clear();
    }
    getItem(key) {
        return this.storage.get(key) !== undefined ? this.storage.get(key) : null;
    }
    key(index) {
        return this.length < index ? null : Array.from(this.storage.keys())[index];
    }
    removeItem(key) {
        this.storage.delete(key);
    }
    setItem(key, value) {
        this.storage.set(key, value);
    }
}
exports.InMemoryStorage = InMemoryStorage;
exports.MemoryStorage = new InMemoryStorage();
//# sourceMappingURL=in-memory-storage.js.map